var map = {
	"./Co-Funded-EU_POS.png": 49033,
	"./EMV-LII_logo.png": 96783,
	"./Emvi_logo_OK.png": 17144,
	"./IGO_Logo.png": 17401,
	"./Teilen_ICON.svg": 31182,
	"./cc-by-sa.svg": 64512,
	"./decidim-logo-mobile.svg": 95733,
	"./mitgestalten-logo.png": 40295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;